
import React from 'react';
import type { Persona } from '../../lib/api/Persona';
import { getPersonaDisplayName } from '../../lib/helpers/personaDisplay';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { LinearProgress } from '@mui/material';
import './PersonaAvatar.css';

interface PersonaAvatarProps {
  persona: Persona;
  index: number;
  loading?: boolean;
}

const PersonaAvatar: React.FC<PersonaAvatarProps> = ({ persona, index, loading }) => {
  return (
    <div className="persona-avatar-card">
      {persona.imageURL ? (
        <img src={persona.imageURL} alt={persona.name} className="persona-avatar-image" />
      ) : (
        <AccountCircle className="persona-avatar-image" />
      )}
      <p className="persona-avatar-name">{getPersonaDisplayName(persona)}</p>
      {loading && <LinearProgress />}
    </div>
  );
};

export default PersonaAvatar;
